import { API_BASE_URL } from "../config/api";
import { safeJson } from "../utils/safeJson";

let _token = null;
export function setToken(token) { _token = token; }

async function req(method, path, body) {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(_token ? { Authorization: `Bearer ${_token}` } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 204) return null;
  const data = await safeJson(res);
  if (!res.ok) throw new Error(data?.error?.message || data?.error || "Erro na requisição");
  return data;
}

// Empresas
export const listCompanies    = ()           => req("GET",    "/admin/company");
export const listAssignableCompanies = ()    => req("GET",    "/admin/company/assignable");
export const createCompany    = (body)       => req("POST",   "/admin/company", body);
export const updateCompany    = (cnpj, body) => req("PUT",    `/admin/company/${cnpj}`, body);
export const deleteCompany    = (cnpj)       => req("DELETE", `/admin/company/${cnpj}`);

// Processos
export const listProcesses    = ()           => req("GET",    "/admin/process");
export const createProcess    = (body)       => req("POST",   "/admin/process", body);
export const updateProcess    = (code, body) => req("PUT",    `/admin/process/${code}`, body);
export const deleteProcess    = (code)       => req("DELETE", `/admin/process/${code}`);

// Etapas
export const listSteps        = (process)    => req("GET",    `/admin/process-step${process ? `?process=${process}` : ""}`);
export const createStep       = (body)       => req("POST",   "/admin/process-step", body);
export const updateStep       = (p, s, body) => req("PUT",    `/admin/process-step/${p}/${s}`, body);
export const deleteStep       = (p, s)       => req("DELETE", `/admin/process-step/${p}/${s}`);

// Determinação de CFOP
export const listCfop         = ()           => req("GET",    "/admin/cfop");
export const createCfop       = (body)       => req("POST",   "/admin/cfop", body);
export const updateCfop       = (cfop, body) => req("PUT",    `/admin/cfop/${cfop}`, body);
export const deleteCfop       = (cfop)       => req("DELETE", `/admin/cfop/${cfop}`);

// Certificados
export const listCertificates = ()           => req("GET",    "/admin/certificate");
export const saveCertificate  = (body)       => req("POST",   "/admin/certificate", body);
export const deleteCertificate= (cnpj)       => req("DELETE", `/admin/certificate/${cnpj}`);

// Logs de integração
export const listIntegrationLogs = (params) =>
  req("GET", "/admin/integration-logs" + (params ? "?" + new URLSearchParams(params) : ""));

// Mensagens administrativas
export const listMessages      = ()           => req("GET",    "/admin/message");
export const getActiveMessages = ()           => req("GET",    `/admin/message/active?_t=${Date.now()}`);
export const createMessage     = (body)       => req("POST",   "/admin/message", body);
export const updateMessage     = (id, body)   => req("PUT",    `/admin/message/${id}`, body);
export const deleteMessage     = (id)         => req("DELETE", `/admin/message/${id}`);

// Configuração de SSO (Microsoft / SAP IAS)
export const listIntegrationConfigs  = ()           => req("GET",    "/admin/integration-config");
export const createIntegrationConfig = (body)       => req("POST",   "/admin/integration-config", body);
export const updateIntegrationConfig = (id, body)   => req("PUT",    `/admin/integration-config/${id}`, body);
export const deleteIntegrationConfig = (id)         => req("DELETE", `/admin/integration-config/${id}`);

// Log de atividades
export const listAuditLog = (params) =>
  req("GET", "/admin/audit-log" + (params ? "?" + new URLSearchParams(params) : ""));

// Versões dos Termos de Uso
export const listTermsVersions  = ()   => req("GET",    "/admin/terms-version");
export const deleteTermsVersion = (id) => req("DELETE", `/admin/terms-version/${id}`);

export async function uploadTermsVersion(file, version, effectiveDate) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("version", version);
  formData.append("effective_date", effectiveDate);

  const res = await fetch(`${API_BASE_URL}/admin/terms-version`, {
    method: "POST",
    headers: { ...(_token ? { Authorization: `Bearer ${_token}` } : {}) },
    body: formData,
  });
  const data = await safeJson(res);
  if (!res.ok) throw new Error(data?.error?.message || data?.error || "Erro ao enviar arquivo");
  return data;
}

// Atualiza uma versão existente (mesmo número) — file é opcional: se não enviado, mantém o PDF atual.
export async function updateTermsVersion(id, effectiveDate, file) {
  const formData = new FormData();
  formData.append("effective_date", effectiveDate);
  if (file) formData.append("file", file);

  const res = await fetch(`${API_BASE_URL}/admin/terms-version/${id}`, {
    method: "PUT",
    headers: { ...(_token ? { Authorization: `Bearer ${_token}` } : {}) },
    body: formData,
  });
  const data = await safeJson(res);
  if (!res.ok) throw new Error(data?.error?.message || data?.error || "Erro ao atualizar versão");
  return data;
}
